/** @jsx jsx */
import { jsx } from '@compiled/react';
import { CommentAction } from '@atlaskit/comment';
import AkToolTip from '@atlaskit/tooltip';
import { ModalEntryPointPressableTrigger } from '@atlassian/jira-modal-entry-point-pressable-trigger/src/ModalEntryPointPressableTrigger.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { deleteIssueLinkConfirmationEntryPoint } from '../confirmation-modal/entrypoint.tsx';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useDelete } from './utils.tsx';

const deleteConfirmModalProps = {
	width: 'small',
	testId: 'issue-comment-base.ui.comment.confirmation-modal.modal-dialog',
};

const DeleteAction = () => {
	const { formatMessage } = useIntl();
	const {
		hasFloatingMenu,
		canDelete,
		jsdIncidentActivityViewHidden,
		commentId,
		eventOccurredAt,
		hasReplies,
		parentId,
		isRealTimeCommentUpdated,
		isThirdPartySyncOn,
	} = useCommentContext();
	const onDeleteClick = useDelete();
	if (!canDelete || hasFloatingMenu) {
		return null;
	}
	if (isThirdPartySyncOn && fg('jira_issue_view_show_slack_sync_info')) {
		return (
			<AkToolTip content={formatMessage(messages.disabledDeleteTooltip)}>
				<CommentAction key="delete" isDisabled>
					{formatMessage(messages.delete)}
				</CommentAction>
			</AkToolTip>
		);
	}

	return (
		<ModalEntryPointPressableTrigger
			entryPoint={deleteIssueLinkConfirmationEntryPoint}
			entryPointProps={{
				commentId,
				eventOccurredAt,
				jsdIncidentActivityViewHidden,
				hasReplies,
				parentId,
				isRealTimeCommentUpdated,
			}}
			modalProps={deleteConfirmModalProps}
			useInternalModal
		>
			{({ ref }) => (
				<CommentAction
					key="delete"
					ref={ref}
					{...(fg('add-analytics-for-delete-comment-ken-1993') && {
						onClick: onDeleteClick,
					})}
				>
					{formatMessage(messages.delete)}
				</CommentAction>
			)}
		</ModalEntryPointPressableTrigger>
	);
};
export default DeleteAction;
